import { useTextes } from '@common/config';
import { Z_EFFECTIF_APPRENTI, Z_ID, Z_NDA, Z_TEXT } from '@common/schemas';
import { Z_CODE_POSTAL, Z_SIRET, Z_UAI } from '@common/schemas/etablissement';
import { Z_NB_RNCP } from '@common/schemas/src/organisme/nb_rncp.schema';
import { z } from 'zod';

const t = useTextes('Commun', 'PopupEtab');

export const editEtablissementInfoFormSchema = z.object({
  id: Z_ID.optional().readonly(),
  principal: z.boolean(),
  siret: Z_SIRET,
  denominationUsuelle: Z_TEXT(),
  nda: Z_NDA,
  uai: Z_UAI,
  effectifApprenti: Z_EFFECTIF_APPRENTI,
  adresse: Z_TEXT(t['POPUP_ETAB_MSG6']),
  complementAdresse: z.string().nullable().optional(),
  codePostal: Z_CODE_POSTAL,
  ville: Z_TEXT(t['POPUP_ETAB_MSG9']),
  nbRncp: Z_NB_RNCP,
  declarationIndividuelle: z.string().optional(),
});

export type EditEtablissementInfoFormResult = z.infer<typeof editEtablissementInfoFormSchema>